import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { DriverPatientGroup } from '@shared/services/gql.service';

export type PatientCurveModel = getEntityType<PatientCurveState>;

export type PatientCurveState = EntityState<
  DriverPatientGroup & {
    patient_group_id: string;
    patient_group_ids: string[];
    showLine: boolean;
  }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ idKey: 'driver_setting_id', name: 'patient-curve' })
export class PatientCurveStore extends EntityStore<PatientCurveState> {
  constructor() {
    super({});
  }
}
